import { createWithRemoteLoader } from '@kne/remote-loader';
import { Col, Row, Space } from 'antd';
import get from 'lodash/get';
import style from './style.module.scss';

const CardInfo = createWithRemoteLoader({
  modules: ['components-core:FormInfo', 'components-core:Enum', 'components-core:FormInfo@useFormContext']
})(({ name, groupLabel, label, rule, remoteModules }) => {
  const [FormInfo, Enum, useFormContext] = remoteModules;
  const { Input, Select } = FormInfo.fields;
  const { formData } = useFormContext();
  return (
    <Space direction={'vertical'} size={2}>
      <div className={style['expect-salary']}>{groupLabel}</div>
      <Row wrap={false} gutter={10}>
        <Col flex={'100px'}>
          <Enum moduleName="cardTypeEnum">
            {data => {
              return (
                <Select
                  name={get(name, '0', 'cardType')}
                  label={get(label, '0', '证件类型')}
                  labelHidden
                  options={data.map(item => ({
                    label: item.description,
                    value: item.value
                  }))}
                />
              );
            }}
          </Enum>
        </Col>
        <Col flex={1}>
          <Input name={get(name, '1', 'card')} label={get(label, '1', '证件号')} rule={formData.cardType === 1 ? 'CARD' : ''} labelHidden />
        </Col>
      </Row>
    </Space>
  );
});

CardInfo.defaultProps = {
  groupLabel: '证件号码'
};

export default CardInfo;
